export const sideDropdownSource = [
  { id: 'Lender', name: 'Lender' },
  { id: 'Borrower', name: 'Borrower' },
]

export const booleanDropdownSource = [
  { id: 'Yes', name: 'Yes' },
  { id: 'No', name: 'No' },
]
